import script from "./OnboardingDone.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingDone.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingDone.vue?vue&type=style&index=0&id=5bcc032a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcc032a"]])

export default __exports__